import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);
  const navRef = useRef(null);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  // Hide/show navbar on scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current) {
        setVisible(false); // Scrolling down
      } else {
        setVisible(true); // Scrolling up
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu if clicking outside (mobile only)
useEffect(() => {
  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY.current) {
      setVisible(false); // Scrolling down
    } else {
      setVisible(true); // Scrolling up
    }
    lastScrollY.current = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);


  return (
    <nav
      className={`navbar ${visible ? "navbar-visible" : "navbar-hidden"}`}
      ref={navRef}
    >
      <div className="logo" onClick={() => scrollToSection("home")}>
        VIGNAN
      </div>

      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        <a onClick={() => scrollToSection("home")}>Home</a>
        <a onClick={() => scrollToSection("events")}>Events</a>
        <a onClick={() => scrollToSection("blog")}>Blog</a>
        <a onClick={() => scrollToSection("contact")}>Contact</a>
        
        <a href="https://forms.gle/RH16qNgFAhEcbJ8x5 ">  <button className="register-btn">Register</button></a>
      
      </div>

      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes size={24} color="#fff" /> : <FaBars size={24} color="#fff" />}
      </div>
    </nav>
  );
};

export default Navbar;
